module.exports = __webpack_public_path__ + "src/assets/games/59/3.png";